// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1m_c9","header":"ReportDetails_header__CRW80","title":"ReportDetails_title__1tYaP","left":"ReportDetails_left__1B-RG"};